// extracted by mini-css-extract-plugin
export default {"subtitle":"page_subtitle__vJC+a","lensLauncher":"page_lensLauncher__UIUIE","launchButton":"page_launchButton__Xvywm","lensLauncherImage":"page_lensLauncherImage__2iFJ4"};